// extracted by mini-css-extract-plugin
export default {"headerActions":"SearchPackages_headerActions__tW+cA","loadingContainer":"SearchPackages_loadingContainer__xxSzE","copyIconButton":"SearchPackages_copyIconButton__yYU2S"};